import React from 'react'
import {Grid} from '@mui/material'
import {RHFTextField} from '../../../common/hook-form'

// "Weight Between" filter for the Channel Orders tabs. Weight is entered in grams, the unit the
// Weight column shows (channel orders store `total_weight` in grams).

export const WEIGHT_FILTER_DEFAULTS = {minWeight: '', maxWeight: ''}

const isBlank = (v) => v === '' || v === null || v === undefined

// Turns the two form fields into search filters, or an error message when the range is not valid.
// Either end may be left empty (only a minimum, or only a maximum).
export function buildWeightFilters({minWeight, maxWeight} = {}) {
  const min = isBlank(minWeight) ? null : Number(minWeight)
  const max = isBlank(maxWeight) ? null : Number(maxWeight)

  if ((min !== null && !Number.isFinite(min)) || (max !== null && !Number.isFinite(max))) {
    return {error: 'Enter the weight as a number (in grams).', filters: []}
  }
  if ((min !== null && min < 0) || (max !== null && max < 0)) {
    return {error: 'Weight cannot be negative.', filters: []}
  }
  if (min !== null && max !== null && min > max) {
    return {error: 'Minimum weight cannot be more than the maximum weight.', filters: []}
  }

  const filters = []
  if (min !== null) filters.push({field: 'total_weight', operator: 'gte', value: min})
  if (max !== null) filters.push({field: 'total_weight', operator: 'lte', value: max})
  return {error: null, filters}
}

// The two inputs, as grid items for the filter form (must be rendered inside a react-hook-form provider).
export function WeightRangeFields() {
  return (
    <>
      <Grid item xs={12} sm={6} md={2}>
        <RHFTextField name='minWeight' label='Min Weight (gm)' type='number' inputProps={{min: 0}} />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <RHFTextField name='maxWeight' label='Max Weight (gm)' type='number' inputProps={{min: 0}} />
      </Grid>
    </>
  )
}
